import { render, staticRenderFns } from "./TicketCreateTime.vue?vue&type=template&id=1b8524b8&scoped=true"
import script from "./TicketCreateTime.vue?vue&type=script&lang=js"
export * from "./TicketCreateTime.vue?vue&type=script&lang=js"
import style0 from "./TicketCreateTime.vue?vue&type=style&index=0&id=1b8524b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8524b8",
  null
  
)

export default component.exports